import React from 'react';
import {
    Stepper,
    Step,
    StepIndicator,
    StepStatus,
    StepTitle,
    StepSeparator,
    StepIcon,
    StepNumber,
    Box,
} from '@chakra-ui/react';

const FileUploadStepper = ({ steps, activeStep }: { steps: string[]; activeStep: number }) => {
    return (
        <Stepper index={activeStep} mb="4" sx={{
            "--stepper-accent-color": "var(--chakra-colors-brand-900)", // 👈 Overrides the stepper line color
        }}>
            {steps.map((step, index) => (
                <Step key={index}>
                    <StepIndicator
                        sx={{
                            '[data-status=complete] &': { background: 'brand.900', borderColor: 'brand.900' },
                            '[data-status=active] &': {
                                background: 'brand.900',
                                borderColor: 'brand.900',
                                color: 'white',
                            },
                            '[data-status=incomplete] &': {
                                background: '#e0e4e8',
                                borderColor: '#e0e4e8',
                                color: '#748094',
                            },
                        }}
                    >
                        <StepStatus complete={<StepIcon />} incomplete={<StepNumber />} active={<StepNumber />} />
                    </StepIndicator>
                    <Box flexShrink="0">
                        <StepTitle>{steps[index]}</StepTitle>
                    </Box>
                    <StepSeparator />
                </Step>
            ))}
        </Stepper>
    );
};

export default FileUploadStepper;
